export default __webpack_public_path__ + "static/media/background-landingpage.89fb08c7.png";